import { lazy } from 'react'

export const CookiePolicy = lazy(() => import('./CookiePolicy'))
